var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 23.333,
    viewBox: "0 0 21 23.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_accessibility_24px",
    d: "M13.5,2a2.333,2.333,0,1,1-2.333,2.333A2.34,2.34,0,0,1,13.5,2ZM24,10.167H17V25.333H14.667v-7H12.333v7H10V10.167H3V7.833H24Z",
    transform: "translate(-3 -2)",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreatment);
export default __webpack_public_path__ + "static/media/treatment.6175ffe7e0680e27475124cf9a7e39e2.svg";
export { ForwardRef as ReactComponent };